import TextField, { type TextFieldProps } from '@mui/material/TextField';
import { type Control, Controller, type FieldPath, type FieldValues } from 'react-hook-form';

type FormTextFieldProps<T extends FieldValues> = Omit<TextFieldProps, 'name'> & {
  name: FieldPath<T>;
  control: Control<T>;
};

/** MUI TextField bound to react-hook-form; shows the field's validation message. */
export function FormTextField<T extends FieldValues>({
  name,
  control,
  helperText,
  error,
  ...props
}: FormTextFieldProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <TextField
          {...props}
          {...field}
          value={field.value ?? ''}
          // `error` from the caller covers checks outside the schema (e.g. "username taken").
          error={error || !!fieldState.error}
          helperText={fieldState.error?.message ?? helperText}
        />
      )}
    />
  );
}
